var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyListNotifications(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3795 50.6046C23.4822 53.2775 26.7855 55 30.5 55C34.2146 55 37.5178 53.2775 39.6205 50.6046C33.5661 51.425 27.4339 51.425 21.3795 50.6046Z",
    fill: "url(#paint0_linear_1932_48658)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3728 24.2603V22.5C47.3728 12.835 39.8186 5 30.5 5C21.1814 5 13.6272 12.835 13.6272 22.5V24.2603C13.6272 26.3727 13.0243 28.4379 11.8945 30.1956L9.1259 34.5029C6.59706 38.4371 8.52762 43.7848 12.9259 45.0289C24.4319 48.2835 36.5681 48.2835 48.0741 45.0289C52.4724 43.7848 54.4029 38.4371 51.8741 34.5029L49.1055 30.1956C47.9757 28.4379 47.3728 26.3727 47.3728 24.2603ZM30.5 13.125C31.5355 13.125 32.375 13.9645 32.375 15V25C32.375 26.0355 31.5355 26.875 30.5 26.875C29.4645 26.875 28.625 26.0355 28.625 25V15C28.625 13.9645 29.4645 13.125 30.5 13.125Z",
    fill: "url(#paint1_linear_1932_48658)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1932_48658",
    x1: 33.4184,
    y1: 5,
    x2: 33.4184,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1932_48658",
    x1: 33.4184,
    y1: 5,
    x2: 33.4184,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyListNotifications);
export default __webpack_public_path__ + "static/media/empty-list-notifications.48730f81c8c16369ee3cbb6cd11f9e2e.svg";
export { ForwardRef as ReactComponent };